import React, { useState, useCallback, useEffect, forwardRef } from "react";
import { FormLayout, TextField, Text, Select } from "@shopify/polaris";
import { HexColorPicker } from "react-colorful";

const BorderStyle = (props) => {
  const handleChangeBorderWidth = (newValue) => {
    props.handleChangeBorderWidth(newValue);
  };
  const handleChangeBorderRadius = (newValue) => {
    props.handleChangeBorderRadius(newValue);
  };
  const handleSelectChangeBorderStyle = (newValue) => {
    props.handleSelectChangeBorderStyle(newValue);
  };
  const handleSelectChangeBorderColor = (newValue) => {
    props.handleSelectChangeBorderColor(newValue);
  };
  const optionsStyles = [
    { label: "Dotted", value: "dotted" },
    { label: "Dashed", value: "dashed" },
    { label: "Solid ", value: "solid" },
    { label: "Double", value: "double" },
    { label: "Groove ", value: "groove " },
    { label: "Ridge", value: "ridge" },
    { label: "Inset", value: "inset" },
    { label: "Outset", value: "outset" },
    { label: "None", value: "none" },
    { label: "Hidden", value: "hidden" },
  ];
  return (
    <FormLayout>
      <Text variant="headingSm" as="h6">
        BORDER STYLE
      </Text>
      <Select
        label="Style"
        options={optionsStyles}
        onChange={handleSelectChangeBorderStyle}
        value={props?.item?.border?.style ? props?.item?.border?.style : ""}
        placeholder="Please select"
      />
      <FormLayout.Group>
        <TextField
          label="Width"
          value={props?.item?.border?.width ? props?.item?.border?.width : ""}
          onChange={handleChangeBorderWidth}
          type="number"
        />
        <TextField
          label="Radius"
          value={props?.item?.border?.radius ? props?.item?.border?.radius : ""}
          onChange={handleChangeBorderRadius}
          type="number"
        />
      </FormLayout.Group>
      <Text as="p" fontWeight="medium">
        Color
      </Text>
      <HexColorPicker
        color={props?.item?.border?.color ? props?.item?.border?.color : ""}
        onChange={handleSelectChangeBorderColor}
      />

      <TextField
        value={props?.item?.border?.color ? props?.item?.border?.color : ""}
        onChange={handleSelectChangeBorderColor}
      />
    </FormLayout>
  );
};

export default BorderStyle;
